
<script>
import { mapActions } from 'vuex'

export default {
  methods:{
    ...mapActions({
      showThisUser: 'Users/setUser', 
    })
  },
  created () {
    this.$auth.logout({
      success (res) {
        this.showThisUser(null)
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
          title: "Até mais!",
          type: "success",
          confirmButtonText: 'OK',
          confirmButtonColor: '#003a3e',
        })
        // alert( "Seja bem vindo "+ this.$auth.user().email)
      }, error (res) {
      console.log('error ' + res.data)
      this.error = res.data  }
    });;
  },
}
</script>

